const PageType = {
  Landing: 'landing',
  Generic: 'generic',
  About: 'about',
  PressRelease: 'pressReleases',
  NewsArticle: 'inTheNews',
};

export default PageType;
